//这个是星空效果，跟随鼠标移动星空
var c;
var $;

var w;
var h;

var arr = [];
var u = 0;
var dep;
var dp = 0.70;
var ms = {
    x: 0,
    y: 0
};
var msd = {
    x: 0,
    y: 0
};
function Obj(x, y, z) {
    this.set(x, y, z);
}

Obj.prototype = {
    set: function(x, y, z) {
        this.x = x || 0;
        this.y = y || 0;
        this.z = z || 0;
    },
    rotX: function(ang) {
        var y = this.y;
        var z = this.z;
        this.y = y * Math.cos(ang) - z * Math.sin(ang);
        this.z = z * Math.cos(ang) + y * Math.sin(ang);
    },
    rotY: function(ang) {
        var x = this.x;
        var z = this.z;
        this.x = x * Math.cos(ang) - z * Math.sin(ang);
        this.z = z * Math.cos(ang) + x * Math.sin(ang);
    },
    rotZ: function(ang) {
        var x = this.x;
        var y = this.y;
        this.x = x * Math.cos(ang) - y * Math.sin(ang);
        this.y = y * Math.cos(ang) + x * Math.sin(ang);
    }
};

function Part(x, y, z) {
    this.op = new Obj(x, y, z);
    this.rp = new Obj(x, y, z);
    this.rot = new Obj();
    this.vel = new Obj();
    this.col = 'hsla(216,95%,85%,' + rnd(0.5, 1) + ')';//216
}

function upd(rot) {
    var rot;
    var vel;
    var op;
    var rp;
    var col;
    for (var i in arr) {
        op = arr[i].op;
        rp = arr[i].rp;
        rot = arr[i].rot;
        vel = arr[i].vel;
        col = arr[i].col;
        vel.x += msd.x * 0.15;
        vel.y += msd.y * 0.15;
        rp.set(op.x, op.y, op.z);

        rot.x += vel.x;
        rot.y += vel.y;
        rot.z += vel.z;

        rot.x = rot.x > Math.PI * 2 ? 0 : rot.x;
        rot.y = rot.y > Math.PI * 2 ? 0 : rot.y;

        rp.rotY(rot.y);
        rp.rotX(rot.x);

        vel.set(
            vel.x * dp,
            vel.y * dp,
            0
        );
    }
    msd.x = 0.0005;
    msd.y = 0.0005;
}

function draw() {
    var p, dth;
    for (var i in arr) {
        p = arr[i];
        dth = ((p.rp.z / dep) + 1);
        $.fillStyle = p.col;
        $.fillRect(w + p.rp.x, h + p.rp.y, rnd(dth / 0.8, dth / 2), dth / 0.9);
    }
}

function rnd(min, max) {
    return Math.random() * (max - min) + min;
}

function go() {
    for (var i = 0; i < 6800; i++) {
        var d = new Part(
            rnd(-w, h),
            rnd(-w, h),
            rnd(-dep, dep)
        );
        d.vel.set(0, 0, 0);
        arr.push(d);
    }
}


function run() {
    $.clearRect(0, 0, w, h);
    var g_ = $.createLinearGradient(c.width + c.width,
        c.height + c.height * 1.5,
        c.width + c.width, 1);
        g_.addColorStop(0, 'hsla(253, 95%, 80%, 1)');//75
    g_.addColorStop(0.5, 'hsla(314, 95%, 19%, 1)');//10
    g_.addColorStop(1, 'hsla(0, 0%, 0%, 1)');
    // g_.addColorStop(0, 'hsla(253, 5%, 75%, 1)');
    // g_.addColorStop(0.5, 'hsla(314, 95%, 10%, 1)');
    // g_.addColorStop(0.8, 'hsla(259, 95%, 5%, 1)');
    // g_.addColorStop(1, 'hsla(0, 0%, 5%, 1)');
    $.globalCompositeOperation = 'normal';
    $.fillStyle = g_;
    $.fillRect(0, 0, w, h);
    $.globalCompositeOperation = 'lighter';
    upd();
    draw();
    window.requestAnimationFrame(run);
}

function mouse(e){
        msd.x = (e.clientY - ms.y) / w;
        msd.y = (e.clientX - ms.x) / h;
        ms.x = e.clientX;
        ms.y = e.clientY;
}

function resize(e){
    c.width = w = window.innerWidth;
    c.height = h = window.innerHeight + 200;
}  
function initAnimate1(cc,$$) {
    c = cc;
    $ = $$;
    w = c.width = window.innerWidth;
    h = c.height = window.innerHeight+200;
    dep = w;
    c.addEventListener('mousemove', function(e){
        mouse(e);
    } , false);
    
    c.addEventListener('resize', resize(), false);
  }
  function startAnimate1(){
    go();
    run();
  }
  
  function cancelAnimate1(){
    // console.log(66666);
      arr = [];
      window.cancelAnimationFrame(run);
      c.removeEventListener('mousemove',mouse);
      c.removeEventListener('resize',resize);
  }
  export { //很关键
   initAnimate1,startAnimate1,cancelAnimate1
  }